var _filter, _filter2, _filter3, _filter4, _filter5, _filter6, _filter7, _clipPath, _clipPath2, _style, _path, _path2, _path3, _path4, _tspan, _path5, _path6, _path7, _g, _path8, _g2, _path9, _circle, _tspan2, _rect, _path0, _path1, _path10, _g3, _text, _path11, _path12, _path13, _g4, _text2, _path14, _path15, _path16, _g5, _text3, _path17, _path18, _path19, _g6, _text4, _path20, _path21, _path22, _g7, _text5, _g8, _ellipse, _ellipse2, _tspan3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlaceholder = function SvgPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 600,
    height: 205
  }, props), /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "placeholder_svg__c",
    x: 77.41,
    y: 42.018,
    width: 71.63,
    height: 203.459,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "d"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#67679d",
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "d"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "placeholder_svg__e",
    x: 165.5,
    y: 96.5,
    width: 280,
    height: 21,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "f"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2d3748",
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "f"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "placeholder_svg__g",
    x: 165.5,
    y: 114.5,
    width: 280,
    height: 21,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "h"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2d3748",
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "h"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  }))), _filter4 || (_filter4 = /*#__PURE__*/React.createElement("filter", {
    id: "placeholder_svg__i",
    x: 165.5,
    y: 151.5,
    width: 280,
    height: 22,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "j"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2d3748",
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "j"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  }))), _filter5 || (_filter5 = /*#__PURE__*/React.createElement("filter", {
    id: "placeholder_svg__k",
    x: 165.5,
    y: 132.5,
    width: 280,
    height: 22,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "l"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2d3748",
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "l"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  }))), _filter6 || (_filter6 = /*#__PURE__*/React.createElement("filter", {
    id: "placeholder_svg__m",
    x: 165.5,
    y: 170.5,
    width: 280,
    height: 21,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "n"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2d3748",
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "n"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  }))), _filter7 || (_filter7 = /*#__PURE__*/React.createElement("filter", {
    id: "placeholder_svg__o",
    x: 395.497,
    y: 77.604,
    width: 154.05,
    height: 58.904,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "p"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#021d67",
    floodOpacity: 0.122
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "p"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "placeholder_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "placeholder_svg__a",
    transform: "translate(291 1376)",
    d: "M0 0h487v190H0z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "placeholder_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "placeholder_svg__a",
    transform: "translate(545 580)",
    d: "M0 0h532v200H0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "placeholder_svg__q"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.312,
    cy: 10.312,
    style: {
      fill: "#fbd38d",
      stroke: "#707070"
    },
    r: 10.312
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".placeholder_svg__a,.placeholder_svg__i{fill:#fff}.placeholder_svg__a{stroke:#707070}.placeholder_svg__c{fill:#1a1c93}.placeholder_svg__j,.placeholder_svg__l,.placeholder_svg__r{fill:none}.placeholder_svg__l{stroke:#7e81ff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.2px}.placeholder_svg__o,.placeholder_svg__t{fill:#5457ff}.placeholder_svg__r{stroke:#edf2f7}.placeholder_svg__s{fill:#f7fafc}.placeholder_svg__t,.placeholder_svg__u{font-size:2px}.placeholder_svg__t{font-family:Nunito-Bold,Nunito;font-weight:700}.placeholder_svg__u{fill:#4a5568;font-family:Nunito-Regular,Nunito}.placeholder_svg__v{fill:#e2e7f5}.placeholder_svg__ab{stroke:none}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "placeholder_svg__c",
    d: "M0 0h600v205H0z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#placeholder_svg__a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-521 -542)",
    style: {
      clipPath: "url(#placeholder_svg__b)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "placeholder_svg__c",
    d: "M608.291 619.564h287.558a2.222 2.222 0 0 1 2.11 2.319v148.722a2.222 2.222 0 0 1-2.11 2.319H608.291a2.222 2.222 0 0 1-2.11-2.319V621.883a2.222 2.222 0 0 1 2.11-2.319Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.862 0h390.122a2.736 2.736 0 0 1 2.862 2.588V168.57a2.736 2.736 0 0 1-2.862 2.588H2.862A2.736 2.736 0 0 1 0 168.57V2.588A2.736 2.736 0 0 1 2.862 0Z",
    transform: "translate(622.646 588.32)",
    style: {
      fill: "#f4f4ff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#e6e9f2",
      fill: "#fff"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "placeholder_svg__ab",
    d: "M626.354 588.131h388.138a4 4 0 0 1 4 4v11.688H622.354v-11.688a4 4 0 0 1 4-4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "placeholder_svg__j",
    d: "M626.354 588.631h388.138a3.5 3.5 0 0 1 3.5 3.5v10.688a.5.5 0 0 1-.5.5H623.354a.5.5 0 0 1-.5-.5v-10.688a3.5 3.5 0 0 1 3.5-3.5Z"
  }))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(632.092 596)",
    style: {
      fill: "#a0aec0",
      fontSize: 3,
      fontFamily: "Mulish-Regular,Mulish"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "marketing.elasticemail.com"))), /*#__PURE__*/React.createElement("path", {
    className: "placeholder_svg__i",
    transform: "translate(622.411 604.015)",
    d: "M0 0h23.63v155.46H0z",
    style: {
      filter: "url(#placeholder_svg__c)"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "placeholder_svg__j",
    d: "M622.41 585.985h23.63v24.252h-23.63z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15.546a6.218 6.218 0 0 1 6.218 6.218 6.218 6.218 0 0 1-6.218 6.218H0V0Z",
    transform: "translate(622.41 613.346)",
    style: {
      fill: "#f8f8ff"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "placeholder_svg__l",
    d: "M630.446 620.528h-.161a.757.757 0 0 1-.758-.757h0v-3.032a.758.758 0 0 1 .758-.758h3.03a.757.757 0 0 1 .758.757h0v.217"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "placeholder_svg__l",
    d: "M631.259 616.956h3.03a.757.757 0 0 1 .758.757h0v3.03a.757.757 0 0 1-.757.758h-3.031a.757.757 0 0 1-.758-.758h0v-3.031a.758.758 0 0 1 .758-.758Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(631.764 617.891)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "placeholder_svg__l",
    cx: 0.808,
    cy: 0.808,
    transform: "translate(.202)",
    r: 0.808
  }), /*#__PURE__*/React.createElement("path", {
    className: "placeholder_svg__l",
    d: "M0 2.627a1.009 1.009 0 0 1 1.009-1.01h0M2.02 2.627a1.01 1.01 0 0 0-1.009-1.01h0"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "placeholder_svg__j",
    d: "M628.999 615.001h6v7h-6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.934 0h3.734A.934.934 0 0 1 5.6.934v3.734a.934.934 0 0 1-.934.934H.934A.934.934 0 0 1 0 4.668V.934A.934.934 0 0 1 .934 0Z",
    transform: "translate(629.49 632.725)",
    style: {
      fill: "transparent",
      stroke: "#7e81ff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2px"
    }
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(631.046 633.876)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "placeholder_svg__l",
    cx: 0.996,
    cy: 0.996,
    r: 0.996,
    transform: "translate(.249)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "placeholder_svg__l",
    d: "M0 3.237a1.244 1.244 0 0 1 1.243-1.245h0M2.49 3.237a1.244 1.244 0 0 0-1.243-1.245h0"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "placeholder_svg__j",
    d: "M628.999 632h6v7h-6z"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "translate(622.41 732.173)",
    style: {
      fill: "#f9faff"
    },
    d: "M0 0h23.649v24.775H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(628.604 738.93)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "placeholder_svg__o",
    cx: 5.631,
    cy: 5.631,
    r: 5.631
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(3.378)",
    style: {
      fontSize: 14,
      fontFamily: "Nunito-SemiBold,Nunito",
      fontWeight: 600,
      fill: "#fff"
    }
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 14
  }, "L")))), /*#__PURE__*/React.createElement("path", {
    transform: "translate(622.551 732.032)",
    style: {
      stroke: "#f3f5f8",
      fill: "none"
    },
    d: "M23.649 0H0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(682.521 626.56)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "placeholder_svg__i",
    width: 288.224,
    height: 121.015,
    rx: 4
  })), /*#__PURE__*/React.createElement("rect", {
    className: "placeholder_svg__j",
    width: 277,
    height: 18,
    rx: 4,
    transform: "translate(5.477 13.441)",
    style: {
      filter: "url(#placeholder_svg__e)"
    }
  }), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "placeholder_svg__r",
    d: "M18.479 31.439h252"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "placeholder_svg__j",
    d: "M264.478 20.44h5.738v5.738h-5.738Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "placeholder_svg__o",
    d: "m268.239 21.911-.072.072a.123.123 0 0 0 0 .174l.86.855h-3.852a.123.123 0 0 0-.123.123v.1a.123.123 0 0 0 .123.123h3.852l-.86.855a.123.123 0 0 0 0 .174l.072.072a.123.123 0 0 0 .174 0l1.194-1.184a.123.123 0 0 0 0-.174l-1.194-1.189a.123.123 0 0 0-.174-.001Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(226.241 18.611)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "placeholder_svg__s",
    width: 15,
    height: 7,
    rx: 3.5,
    transform: "translate(.237 -.171)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "placeholder_svg__t",
    transform: "translate(3.237 3.829)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Valid")))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "placeholder_svg__u",
    transform: "translate(18.479 22.44)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "sprezult0@gmail.com "))), /*#__PURE__*/React.createElement("rect", {
    className: "placeholder_svg__j",
    width: 277,
    height: 18,
    rx: 4,
    transform: "translate(5.477 31.437)",
    style: {
      filter: "url(#placeholder_svg__g)"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "placeholder_svg__r",
    d: "M18.479 49.44h252"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "placeholder_svg__j",
    d: "M264.478 37.44h5.738v5.738h-5.738Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "placeholder_svg__o",
    d: "m268.239 38.911-.072.072a.123.123 0 0 0 0 .174l.86.855h-3.852a.123.123 0 0 0-.123.123v.1a.123.123 0 0 0 .123.123h3.852l-.86.855a.123.123 0 0 0 0 .174l.072.072a.123.123 0 0 0 .174 0l1.194-1.184a.123.123 0 0 0 0-.174l-1.194-1.189a.123.123 0 0 0-.174-.001Z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(226.241 37.897)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "placeholder_svg__s",
    width: 15,
    height: 7,
    rx: 3.5,
    transform: "translate(.237 -.457)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "placeholder_svg__t",
    transform: "translate(3.237 3.543)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Valid")))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "placeholder_svg__u",
    transform: "translate(18.479 39.44)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "sprezult0@gmail.com "))), /*#__PURE__*/React.createElement("rect", {
    className: "placeholder_svg__j",
    width: 277,
    height: 19,
    rx: 4,
    transform: "translate(5.477 68.437)",
    style: {
      filter: "url(#placeholder_svg__i)"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "placeholder_svg__r",
    d: "M18.479 87.439h252"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "placeholder_svg__j",
    d: "M264.478 74.44h5.738v5.738h-5.738Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "placeholder_svg__o",
    d: "m268.239 75.911-.072.072a.123.123 0 0 0 0 .174l.86.855h-3.852a.123.123 0 0 0-.123.123v.1a.123.123 0 0 0 .123.123h3.852l-.86.855a.123.123 0 0 0 0 .174l.072.072a.123.123 0 0 0 .174 0l1.194-1.184a.123.123 0 0 0 0-.174l-1.194-1.189a.123.123 0 0 0-.174-.001Z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(226.241 73.807)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "placeholder_svg__s",
    width: 15,
    height: 7,
    rx: 3.5,
    transform: "translate(.237 -.367)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "placeholder_svg__t",
    transform: "translate(3.237 3.633)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Valid")))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "placeholder_svg__u",
    transform: "translate(18.479 76.44)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "sprezult0@gmail.com "))), /*#__PURE__*/React.createElement("rect", {
    className: "placeholder_svg__j",
    width: 277,
    height: 19,
    rx: 4,
    transform: "translate(5.477 49.437)",
    style: {
      filter: "url(#placeholder_svg__k)"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "placeholder_svg__r",
    d: "M18.479 68.44h252"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "placeholder_svg__j",
    d: "M264.478 56.44h5.738v5.738h-5.738Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "placeholder_svg__o",
    d: "m268.239 57.911-.072.072a.123.123 0 0 0 0 .174l.86.855h-3.852a.123.123 0 0 0-.123.123v.1a.123.123 0 0 0 .123.123h3.852l-.86.855a.123.123 0 0 0 0 .174l.072.072a.123.123 0 0 0 .174 0l1.194-1.184a.123.123 0 0 0 0-.174l-1.194-1.189a.123.123 0 0 0-.174-.001Z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(226.241 55.852)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "placeholder_svg__s",
    width: 15,
    height: 7,
    rx: 3.5,
    transform: "translate(.237 -.412)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "placeholder_svg__t",
    transform: "translate(3.237 3.588)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Valid")))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "placeholder_svg__u",
    transform: "translate(18.479 58.44)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "sprezult0@gmail.com "))), /*#__PURE__*/React.createElement("rect", {
    className: "placeholder_svg__j",
    width: 277,
    height: 18,
    rx: 4,
    transform: "translate(5.477 87.437)",
    style: {
      filter: "url(#placeholder_svg__m)"
    }
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "placeholder_svg__r",
    d: "M18.479 105.439h252"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "placeholder_svg__j",
    d: "M264.478 93.439h5.738v5.738h-5.738Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "placeholder_svg__o",
    d: "m268.239 94.91-.072.072a.123.123 0 0 0 0 .174l.86.855h-3.852a.123.123 0 0 0-.123.123v.1a.123.123 0 0 0 .123.123h3.852l-.86.855a.123.123 0 0 0 0 .174l.072.072a.123.123 0 0 0 .174 0l1.194-1.184a.123.123 0 0 0 0-.174l-1.194-1.189a.123.123 0 0 0-.174-.001Z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(226.241 92.427)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "placeholder_svg__s",
    width: 15,
    height: 7,
    rx: 3.5,
    transform: "translate(.237 .012)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "placeholder_svg__t",
    transform: "translate(3.237 3.012)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Valid")))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "placeholder_svg__u",
    transform: "translate(18.479 95.439)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "sprezult0@gmail.com ")))), /*#__PURE__*/React.createElement("path", {
    className: "placeholder_svg__i",
    d: "M2.94 0h118.17c1.624 0 2.94 1.687 2.94 3.768v21.369c0 2.081-1.316 3.768-2.94 3.768H2.94C1.316 28.9 0 27.217 0 25.137V3.768C0 1.687 1.316 0 2.94 0Z",
    transform: "translate(931.497 631.604)",
    style: {
      filter: "url(#placeholder_svg__o)"
    }
  }), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(971.134 641.568)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "placeholder_svg__v",
    width: 77.033,
    height: 3.984,
    rx: 1.992,
    transform: "translate(0 7.708)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "placeholder_svg__v",
    width: 31.998,
    height: 2.354,
    rx: 1.177
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#placeholder_svg__q)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(938.05 634.413)",
    style: {
      fill: "#fbd38d"
    },
    d: "M0 0h25.253v25.253H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(683 610)",
    style: {
      fill: "#edf2f7",
      stroke: "#e2e8f0"
    }
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "placeholder_svg__ab",
    cx: 6,
    cy: 6.5,
    rx: 6,
    ry: 6.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "placeholder_svg__j",
    cx: 6,
    cy: 6.5,
    rx: 5.5,
    ry: 6
  }))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(699 618)",
    style: {
      fill: "#32325c",
      fontSize: 7,
      fontFamily: "Nunito-Regular,Nunito"
    }
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Bulk Verification"))), /*#__PURE__*/React.createElement("path", {
    d: "M8.65 2a6.65 6.65 0 1 0 6.65 6.65A6.653 6.653 0 0 0 8.65 2Zm-1.8 9.5L4.461 9.116a.663.663 0 0 1 .939-.938l1.92 1.915 4.58-4.575a.663.663 0 0 1 .938.938L7.786 11.5a.662.662 0 0 1-.938 0Z",
    transform: "translate(998 623)",
    style: {
      fill: "#38b2ac"
    }
  }))));
};
export default SvgPlaceholder;